/**
 * Format an array of tags into a string to be used as a tagExpression
 *
 * @param tagValues
 * @returns {string} The formatted string to use in the param
 */
export const formatTagsForTagExpression = (tagValues = []) => {
    return PULSE.app.common.url.formatTagsForTagExpression(tagValues);
};
